import { Route } from 'react-router-dom'
import { NoMatch } from '../../../components/pages/public/NoMatch'
import { paths } from '../../paths'

export const noMatch: JSX.Element[] = [<Route component={NoMatch} exact key={paths.noMatch} path={paths.noMatch} />]
